const isBrowser = typeof window !== 'undefined' &amp;&amp; typeof document !== 'undefined';
const longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
let timeoutDuration = 0;
for (let i = 0; i &lt; longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser &amp;&amp; navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) &gt;= 0) {
    timeoutDuration = 1;
    break;
  }
}

export function microtaskDebounce(fn) {
  let called = false
  return () =&gt; {
    if (called) {
      return
    }
    called = true
    window.Promise.resolve().then(() =&gt; {
      called = false
      fn()
    })
  }
}

export function taskDebounce(fn) {
  let scheduled = false;
  return () =&gt; {
    if (!scheduled) {
      scheduled = true;
      setTimeout(() =&gt; {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

const supportsMicroTasks = isBrowser &amp;&amp; window.Promise


/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
export default (supportsMicroTasks
  ? microtaskDebounce
  : taskDebounce);
